import { isAvailableRegion } from '../../../../JsonQuery';
import { DemolitionContainer } from '../../containers/advancedFilters/DemolitionContainer';
import { IFilter } from '../../types/advancedFilters';
import { MOSCOW_ID } from '../regions';

export const demolition: IFilter = {
  availability: ({ jsonQuery }) => isAvailableRegion([MOSCOW_ID])(jsonQuery),
  component: DemolitionContainer,
};
